export default __webpack_public_path__ + "static/media/CyclingManIcon.e5465ae1.svg";